















import _ from 'lodash'
import { BaseForm } from '@/services/BaseForm'
import { Component, Provide } from 'vue-property-decorator'
import { IFormOption, INPUT_TYPES } from '@/components/form/FieldTypes'
import RuleHelper from '@/utils/RuleHelper'
import { IJob } from '@/store/modules/views/job/states'
import { Action, Getter } from 'vuex-class'

@Component
export default class JobAssessment extends BaseForm<any> {
  @Provide('formName') public formName = 'job_form'

  private header = `แบบประเมินความพึงพอใจต่อการให้บริการของนักบริบาล`
  private loading = false
  private data: { [key: string]: any }
  private isReadOnly = false

  @Getter('job/jobById')
  private jobById!: IJob

  @Action('job/getJobById')
  private getJobById!: (options: {}) => void

  @Action('job/putJob')
  private putJob!: (options: {}) => void

  public async mounted() {
    this.loading = true
    if (this.$route.params.status) {
      await this.getJobById({ _id: this.$route.params.status })
    }
    this.loading = false
  }

  get formDefault(): any {
    return this.jobById ? this.doConvertIntToString(this.jobById.metadata) : {}
  }

  get personalize(): IFormOption[] {
    return [
      {
        type: INPUT_TYPES.TEXTAREA,
        col: '12',
        props: {
          name: 'personalizeDisease',
          title: 'โรค / ปัญหาสุขภาพ',
          dense: true,
          defaultValue: this.formDefault && this.formDefault.personalizeDisease
            ? this.formDefault.personalizeDisease
            : undefined,
        },
      },
    ]
  }

  get assessment_level(): IFormOption[] {
    return [
      {
        type: INPUT_TYPES.TITLE,
        col: '12',
        props: {
          title: 'การประเมินภาพรวม',
        },
      },
      {
        type: INPUT_TYPES.RADIO,
        col: '12',
        props: {
          name: 'assessmentLevel',
          defaultValue: this.formDefault && this.formDefault.assessmentLevel
            ? this.formDefault.assessmentLevel
            : undefined,
          direction: { row: true, column: false },
          options: [
            { text: 'ดีเด่น (90-100%)', value: '5' },
            { text: 'ดีมาก (80-89%)', value: '4' },
            { text: 'ดี (70-79%)', value: '3' },
            { text: 'พอใช้ (60-69%)', value: '2' },
            { text: 'ต้องปรับปรุง (ต่ำกว่า 60%)', value: '1' },
          ],
        },
      },
    ]
  }

  get physical_examination(): IFormOption[] {
    return [
      {
        type: INPUT_TYPES.TITLE,
        col: '12',
        props: {
          title: 'ระดับความคิดเห็นของผู้ประเมิน ต่อผู้ช่วยเหลือดูแลผู้สูงอายุที่มีภาวะพึ่งพิง',
        },
      },
      {
        type: INPUT_TYPES.SUBTITLE,
        col: '12',
        props: {
          title: '(5=พึงพอใจมากที่สุด 4=พึงพอใจมาก 3=พึงพอใจปานกลาง 2=พึงพอใจน้อย 1=ไม่พอใจ)',
        },
      },
      {
        type: INPUT_TYPES.SUBTITLE,
        col: '12',
        props: {
          title: '<span class="grey--text text--darken-2 font-weight-bold">ส่วนที่ 1 ด้านทั่วไปของนักบริบาลดูแลผู้สูงอายุ</span>',
          className: 'my-4',
        },
      },
      {
        type: INPUT_TYPES.SUBTITLE,
        col: '7',
        props: {
          title: '1. มีการแต่งกายที่เหมาะสม และสะอาด',
          className: 'mt-4',
        },
      },
      {
        type: INPUT_TYPES.RADIO,
        col: '5',
        props: {
          name: 'physicalExaminationOutfitPart1No1',
          defaultValue: this.formDefault && this.formDefault.physicalExaminationOutfitPart1No1
            ? this.formDefault.physicalExaminationOutfitPart1No1
            : undefined,
          direction: { row: true, column: false },
          options: [
            { text: '5', value: '5' },
            { text: '4', value: '4' },
            { text: '3', value: '3' },
            { text: '2', value: '2' },
            { text: '1', value: '1' },
          ],
        },
      },
      {
        type: INPUT_TYPES.SUBTITLE,
        col: '7',
        props: {
          title: '2. มีความประพฤติที่เหมาะสมต่อผู้สูงอายุ',
          className: 'mt-4',
        },
      },
      {
        type: INPUT_TYPES.RADIO,
        col: '5',
        props: {
          name: 'physicalExaminationBehaviorPart1No2',
          defaultValue: this.formDefault && this.formDefault.physicalExaminationBehaviorPart1No2
            ? this.formDefault.physicalExaminationBehaviorPart1No2
            : undefined,
          direction: { row: true, column: false },
          options: [
            { text: '5', value: '5' },
            { text: '4', value: '4' },
            { text: '3', value: '3' },
            { text: '2', value: '2' },
            { text: '1', value: '1' },
          ],
        },
      },
      {
        type: INPUT_TYPES.SUBTITLE,
        col: '7',
        props: {
          title: '3. มีความประพฤติที่เหมาะสมต่อญาติของผู้สูงอายุ/ผู้ป่วย',
          className: 'mt-4',
        },
      },
      {
        type: INPUT_TYPES.RADIO,
        col: '5',
        props: {
          name: 'physicalExaminationBehaviorWithRelativePart1No3',
          defaultValue: this.formDefault && this.formDefault.physicalExaminationBehaviorWithRelativePart1No3
            ? this.formDefault.physicalExaminationBehaviorWithRelativePart1No3
            : undefined,
          direction: { row: true, column: false },
          options: [
            { text: '5', value: '5' },
            { text: '4', value: '4' },
            { text: '3', value: '3' },
            { text: '2', value: '2' },
            { text: '1', value: '1' },
          ],
        },
      },
      {
        type: INPUT_TYPES.SUBTITLE,
        col: '7',
        props: {
          title: '4. มีน้ําใจ มีความเมตตากรุณาต่อผู้สูงอายุ/ผู้ป่วย',
          className: 'mt-4',
        },
      },
      {
        type: INPUT_TYPES.RADIO,
        col: '5',
        props: {
          name: 'physicalExaminationCompassionatePart1No4',
          defaultValue: this.formDefault && this.formDefault.physicalExaminationCompassionatePart1No4
            ? this.formDefault.physicalExaminationCompassionatePart1No4
            : undefined,
          direction: { row: true, column: false },
          options: [
            { text: '5', value: '5' },
            { text: '4', value: '4' },
            { text: '3', value: '3' },
            { text: '2', value: '2' },
            { text: '1', value: '1' },
          ],
        },
      },
      {
        type: INPUT_TYPES.SUBTITLE,
        col: '12',
        props: {
          title: '<span class="grey--text text--darken-2 font-weight-bold">ส่วนที่ 2 ด้านการพยาบาลดูแลผู้สูงอายุ/ผู้ป่วย</span>',
          className: 'my-4',
        },
      },
      {
        type: INPUT_TYPES.SUBTITLE,
        col: '7',
        props: {
          title: '1. มีความสามารถในการประเมินปัญหาสุขภาพของผู้สูงอายุ/ผู้ป่วย',
          className: 'mt-4',
        },
      },
      {
        type: INPUT_TYPES.RADIO,
        col: '5',
        props: {
          name: 'physicalExaminationAssessmentPart2No1',
          defaultValue: this.formDefault && this.formDefault.physicalExaminationAssessmentPart2No1
            ? this.formDefault.physicalExaminationAssessmentPart2No1
            : undefined,
          direction: { row: true, column: false },
          options: [
            { text: '5', value: '5' },
            { text: '4', value: '4' },
            { text: '3', value: '3' },
            { text: '2', value: '2' },
            { text: '1', value: '1' },
          ],
        },
      },
      {
        type: INPUT_TYPES.SUBTITLE,
        col: '7',
        props: {
          title: '2. ให้การพยาบาลดูแลตามแผนการพยาบาลดูแล (Care Plan)',
          className: 'mt-4',
        },
      },
      {
        type: INPUT_TYPES.RADIO,
        col: '5',
        props: {
          name: 'physicalExaminationCarePlanPart2No2',
          defaultValue: this.formDefault && this.formDefault.physicalExaminationCarePlanPart2No2
            ? this.formDefault.physicalExaminationCarePlanPart2No2
            : undefined,
          direction: { row: true, column: false },
          options: [
            { text: '5', value: '5' },
            { text: '4', value: '4' },
            { text: '3', value: '3' },
            { text: '2', value: '2' },
            { text: '1', value: '1' },
          ],
        },
      },
      {
        type: INPUT_TYPES.SUBTITLE,
        col: '7',
        props: {
          title: '3. มีความสามารถในการประเมินผลการพยาบาลดูแล',
          className: 'mt-4',
        },
      },
      {
        type: INPUT_TYPES.RADIO,
        col: '5',
        props: {
          name: 'physicalExaminationNurseAssessmentPart2No3',
          defaultValue: this.formDefault && this.formDefault.physicalExaminationNurseAssessmentPart2No3
            ? this.formDefault.physicalExaminationNurseAssessmentPart2No3
            : undefined,
          direction: { row: true, column: false },
          options: [
            { text: '5', value: '5' },
            { text: '4', value: '4' },
            { text: '3', value: '3' },
            { text: '2', value: '2' },
            { text: '1', value: '1' },
          ],
        },
      },
      {
        type: INPUT_TYPES.SUBTITLE,
        col: '7',
        props: {
          title: '4. มีความสามารถในการบันทึกรายงานการพยาบาลดูแลผู้สูงอายุ/ผู้ป่วย',
          className: 'mt-4',
        },
      },
      {
        type: INPUT_TYPES.RADIO,
        col: '5',
        props: {
          name: 'physicalExaminationNoteAssessmentPart2No4',
          defaultValue: this.formDefault && this.formDefault.physicalExaminationNoteAssessmentPart2No4
            ? this.formDefault.physicalExaminationNoteAssessmentPart2No4
            : undefined,
          direction: { row: true, column: false },
          options: [
            { text: '5', value: '5' },
            { text: '4', value: '4' },
            { text: '3', value: '3' },
            { text: '2', value: '2' },
            { text: '1', value: '1' },
          ],
        },
      },
      {
        type: INPUT_TYPES.SUBTITLE,
        col: '7',
        props: {
          title: '5. มีความสามารถในการให้ความรู้และการปฏิบัติตัวที่ถูกต้อง ต่อผู้สูงอายุ และญาติ',
          className: 'mt-4',
        },
      },
      {
        type: INPUT_TYPES.RADIO,
        col: '5',
        props: {
          name: 'physicalExaminationShareKnowledgePart2No5',
          defaultValue: this.formDefault && this.formDefault.physicalExaminationShareKnowledgePart2No5
            ? this.formDefault.physicalExaminationShareKnowledgePart2No5
            : undefined,
          direction: { row: true, column: false },
          options: [
            { text: '5', value: '5' },
            { text: '4', value: '4' },
            { text: '3', value: '3' },
            { text: '2', value: '2' },
            { text: '1', value: '1' },
          ],
        },
      },
      {
        type: INPUT_TYPES.SUBTITLE,
        col: '7',
        props: {
          title: '6. มีความสามารถในการประสานการดูแลช่วยเหลือด้านสังคมของผู้สูงอายุ/ผู้ป่วย',
          className: 'mt-4',
        },
      },
      {
        type: INPUT_TYPES.RADIO,
        col: '5',
        props: {
          name: 'physicalExaminationHelpSocialPart2No6',
          defaultValue: this.formDefault && this.formDefault.physicalExaminationHelpSocialPart2No6
            ? this.formDefault.physicalExaminationHelpSocialPart2No6
            : undefined,
          direction: { row: true, column: false },
          options: [
            { text: '5', value: '5' },
            { text: '4', value: '4' },
            { text: '3', value: '3' },
            { text: '2', value: '2' },
            { text: '1', value: '1' },
          ],
        },
      },
      {
        type: INPUT_TYPES.SUBTITLE,
        col: '7',
        props: {
          title: '7. มีความสามารถในการประสานการดูแลช่วยเหลือด้านสิ่งแวดล้อมของผู้สูงอายุ/ผู้ป่วย',
          className: 'mt-4',
        },
      },
      {
        type: INPUT_TYPES.RADIO,
        col: '5',
        props: {
          name: 'physicalExaminationHelpEnvironmentPart2No7',
          defaultValue: this.formDefault && this.formDefault.physicalExaminationHelpEnvironmentPart2No7
            ? this.formDefault.physicalExaminationHelpEnvironmentPart2No7
            : undefined,
          direction: { row: true, column: false },
          options: [
            { text: '5', value: '5' },
            { text: '4', value: '4' },
            { text: '3', value: '3' },
            { text: '2', value: '2' },
            { text: '1', value: '1' },
          ],
        },
      },
      {
        type: INPUT_TYPES.SUBTITLE,
        col: '7',
        props: {
          title: '8. มีความสามารถในการประสานการดูแลช่วยเหลือด้านเศรษฐกิจของผู้สูงอายุ/ผู้ป่วย',
          className: 'mt-4',
        },
      },
      {
        type: INPUT_TYPES.RADIO,
        col: '5',
        props: {
          name: 'physicalExaminationHelpEconomyPart2No8',
          defaultValue: this.formDefault && this.formDefault.physicalExaminationHelpEconomyPart2No8
            ? this.formDefault.physicalExaminationHelpEconomyPart2No8
            : undefined,
          direction: { row: true, column: false },
          options: [
            { text: '5', value: '5' },
            { text: '4', value: '4' },
            { text: '3', value: '3' },
            { text: '2', value: '2' },
            { text: '1', value: '1' },
          ],
        },
      },
      {
        type: INPUT_TYPES.SUBTITLE,
        col: '12',
        props: {
          title: '<span class="grey--text text--darken-2 font-weight-bold">ส่วนที่ 3 ความคิดเห็นอื่นๆ</span>',
          className: 'my-4',
        },
      },
      {
        type: INPUT_TYPES.TEXTAREA,
        col: '12',
        props: {
          name: 'physicalExaminationOpinion',
          defaultValue: this.formDefault && this.formDefault.physicalExaminationOpinion
            ? this.formDefault.physicalExaminationOpinion
            : undefined,
        },
      },
    ]
  }

  private async submitForm(data) {
    this.data = this.doConvertStringToInt(data)
    try {
      this.loading = true
      await this.putJob({
        _id: this.$route.params.status,
        metadata: this.data,
        status: 'ทำแบบประเมินแล้ว',
      })
      this.updateSnackbar({txt: 'บันทึกข้อมูลแบบสอบถามสำเร็จ', type: 'success'})
      this.loading = false
      this.$router.push(`/main/job`)
    } catch (e) {
      this.loading = false
    }
  }
}
